import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__collections } from '../STATE__collections';

export const remote_collection_get_shared_by_id = createAsyncThunkSafe<DTO_RESPONSE__success | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.COLLECTION_GET_SHARED_BY_ID,
  async (id): Promise<DTO_RESPONSE__success | DTO_RESPONSE__error> => {
    return await send_to_server<DTO_RESPONSE__success | DTO_RESPONSE__error>(ENUM__network_event_client_to_server.COLLECTION_GET_SHARED_BY_ID, id);
  },
);

export function init_remote_collection_get_shared_by_id(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(remote_collection_get_shared_by_id.pending, (state, action) => {})
    .addCase(remote_collection_get_shared_by_id.rejected, (state, action) => {})
    .addCase(remote_collection_get_shared_by_id.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__success | DTO_RESPONSE__error>) => {});
}
